export const comboApis = {
  City: [
    {
      key: "Karachi",
      value: "Karachi",
    },
    {
      key: "Gawadar",
      value: "Gawadar",
    },
    {
      key: "Turbat",
      value: "Turbat",
    },
    {
      key: "Quetta",
      value: "Quetta",
    },
    {
      key: "Ormara",
      value: "Ormara",
    },
    {
      key: "Karachi",
      value: "Karachi",
    },
    {
      key: "Khuzdar",
      value: "Khuzdar",
    },
    {
      key: "Zhob",
      value: "Zhob",
    },
    {
      key: "Muslim Bagh",
      value: "Muslim Bagh",
    },
    {
      key: "Loralai",
      value: "Loralai",
    },
    {
      key: "Hyderabad ",
      value: "Hyderabad ",
    },
    {
      key: "Thatta ",
      value: "Thatta ",
    },
    {
      key: "Jamshoro ",
      value: "Jamshoro ",
    },
    {
      key: "Mirpur Khas ",
      value: "Mirpur Khas ",
    },
    {
      key: "Kot Ghulam Muhammad ",
      value: "Kot Ghulam Muhammad ",
    },
    {
      key: "Kunri ",
      value: "Kunri ",
    },
    {
      key: "Tando Allah Yar ",
      value: "Tando Allah Yar ",
    },
    {
      key: "Sultanabad ",
      value: "Sultanabad ",
    },
    {
      key: "Maatli ",
      value: "Maatli ",
    },
    {
      key: "Umer Kot ",
      value: "Umer Kot ",
    },
    {
      key: "Tando Jam ",
      value: "Tando Jam ",
    },
    {
      key: "Mithi ",
      value: "Mithi ",
    },
    {
      key: "Badin ",
      value: "Badin ",
    },
    {
      key: "Tando Muhammad Khan ",
      value: "Tando Muhammad Khan ",
    },
    {
      key: "Sheikh Bhirkio ",
      value: "Sheikh Bhirkio ",
    },
    {
      key: "Digri ",
      value: "Digri ",
    },
    {
      key: "Chambar ",
      value: "Chambar ",
    },
    {
      key: "Khairpur",
      value: "Khairpur",
    },
    {
      key: "Sukkur",
      value: "Sukkur",
    },
    {
      key: "Pano Aqil",
      value: "Pano Aqil",
    },
    {
      key: "Ghotki",
      value: "Ghotki",
    },
    {
      key: "Mirpur Mathelo",
      value: "Mirpur Mathelo",
    },
    {
      key: "Daharki",
      value: "Daharki",
    },
    {
      key: "Moro",
      value: "Moro",
    },
    {
      key: "Naushahro Feroze",
      value: "Naushahro Feroze",
    },
    {
      key: "Bhiria City",
      value: "Bhiria City",
    },
    {
      key: "Sanghar",
      value: "Sanghar",
    },
    {
      key: "Shahdadpur",
      value: "Shahdadpur",
    },
    {
      key: "Nawabshah",
      value: "Nawabshah",
    },
    {
      key: "Larkana",
      value: "Larkana",
    },
    {
      key: "Shahdadkot",
      value: "Shahdadkot",
    },
    {
      key: "Mehar",
      value: "Mehar",
    },
    {
      key: "Sehwan",
      value: "Sehwan",
    },
    {
      key: "Shikarpur",
      value: "Shikarpur",
    },
    {
      key: "Kandhkot",
      value: "Kandhkot",
    },
    {
      key: "Kashmore",
      value: "Kashmore",
    },
    {
      key: "Lahore",
      value: "Lahore",
    },
    {
      key: "Kasur",
      value: "Kasur",
    },
    {
      key: "Okara",
      value: "Okara",
    },
    {
      key: "Depalpur",
      value: "Depalpur",
    },
    {
      key: "Pattoki",
      value: "Pattoki",
    },
    {
      key: "Pak Pattan",
      value: "Pak Pattan",
    },
    {
      key: "Arifwala",
      value: "Arifwala",
    },
    {
      key: "Gujranwala",
      value: "Gujranwala",
    },
    {
      key: "Ghakkhar Mandi",
      value: "Ghakkhar Mandi",
    },
    {
      key: "Kamoki",
      value: "Kamoki",
    },
    {
      key: "Lalamusa",
      value: "Lalamusa",
    },
    {
      key: "Hafizabad",
      value: "Hafizabad",
    },
    {
      key: "Muridke",
      value: "Muridke",
    },
    {
      key: "Sheikhupura",
      value: "Sheikhupura",
    },
    {
      key: "Kharian",
      value: "Kharian",
    },
    {
      key: "Gujrat",
      value: "Gujrat",
    },
    {
      key: "Mandi Bahauddin",
      value: "Mandi Bahauddin",
    },
    {
      key: "Dinga",
      value: "Dinga",
    },
    {
      key: "Gulyana",
      value: "Gulyana",
    },
    {
      key: "Wazirabad",
      value: "Wazirabad",
    },
    {
      key: "Sialkot",
      value: "Sialkot",
    },
    {
      key: "Sambrial",
      value: "Sambrial",
    },
    {
      key: "Gohadpur",
      value: "Gohadpur",
    },
    {
      key: "Ugoki",
      value: "Ugoki",
    },
    {
      key: "Daska",
      value: "Daska",
    },
    {
      key: "Faisalabad",
      value: "Faisalabad",
    },
    {
      key: "Toba Tek Singh",
      value: "Toba Tek Singh",
    },
    {
      key: "Gojra",
      value: "Gojra",
    },
    {
      key: "Sargodha",
      value: "Sargodha",
    },
    {
      key: "Rabwa",
      value: "Rabwa",
    },
    {
      key: "Chiniot",
      value: "Chiniot",
    },
    {
      key: "Multan",
      value: "Multan",
    },
    {
      key: "DG Khan",
      value: "DG Khan",
    },
    {
      key: "Muzaffargarh",
      value: "Muzaffargarh",
    },
    {
      key: "Taunsa",
      value: "Taunsa",
    },
    {
      key: "Kot Addu",
      value: "Kot Addu",
    },
    {
      key: "Bhakkar",
      value: "Bhakkar",
    },
    {
      key: "Layyah",
      value: "Layyah",
    },
    {
      key: "Khanewal",
      value: "Khanewal",
    },
    {
      key: "Burewala",
      value: "Burewala",
    },
    {
      key: "Vehari",
      value: "Vehari",
    },
    {
      key: "Sahiwal",
      value: "Sahiwal",
    },
    {
      key: "Chichawatni",
      value: "Chichawatni",
    },
    {
      key: "Mian Chunnoo",
      value: "Mian Chunnoo",
    },
    {
      key: "Rahimyar Khan",
      value: "Rahimyar Khan",
    },
    {
      key: "Sadiqabad",
      value: "Sadiqabad",
    },
    {
      key: "Khanpur",
      value: "Khanpur",
    },
    {
      key: "Haroonabad",
      value: "Haroonabad",
    },
    {
      key: "Bahawalnagar",
      value: "Bahawalnagar",
    },
    {
      key: "Chistian",
      value: "Chistian",
    },
    {
      key: "Dharanwala",
      value: "Dharanwala",
    },
    {
      key: "Bahawalpur",
      value: "Bahawalpur",
    },
    {
      key: "Lodhran",
      value: "Lodhran",
    },
    {
      key: "Hasilpur",
      value: "Hasilpur",
    },
    {
      key: "Islamabad",
      value: "Islamabad",
    },
    {
      key: "Rawalpindi",
      value: "Rawalpindi",
    },
    {
      key: "Muzaffarabad",
      value: "Muzaffarabad",
    },
    {
      key: "Bagh AJK",
      value: "Bagh AJK",
    },
    {
      key: "Taxila",
      value: "Taxila",
    },
    {
      key: "Attock",
      value: "Attock",
    },
    {
      key: "Chakwal",
      value: "Chakwal",
    },
    {
      key: "Jehlum",
      value: "Jehlum",
    },
    {
      key: "Mirpur Ak",
      value: "Mirpur Ak",
    },
    {
      key: "Chaksawari Ak",
      value: "Chaksawari Ak",
    },
    {
      key: "Jatlan Ak",
      value: "Jatlan Ak",
    },
    {
      key: "Dadyal",
      value: "Dadyal",
    },
    {
      key: "Charroi",
      value: "Charroi",
    },
    {
      key: "Sehensa",
      value: "Sehensa",
    },
    {
      key: "Seri",
      value: "Seri",
    },
    {
      key: "Kotli Ak",
      value: "Kotli Ak",
    },
    {
      key: "Khui Ratta Ak",
      value: "Khui Ratta Ak",
    },
    {
      key: "Naarr",
      value: "Naarr",
    },
    {
      key: "Peshawar",
      value: "Peshawar",
    },
    {
      key: "Shakas",
      value: "Shakas",
    },
    {
      key: "Saleh Khana",
      value: "Saleh Khana",
    },
    {
      key: "DI Khan",
      value: "DI Khan",
    },
    {
      key: "Bannu",
      value: "Bannu",
    },
    {
      key: "Darra Adam Khel",
      value: "Darra Adam Khel",
    },
    {
      key: "Parachinar",
      value: "Parachinar",
    },
    {
      key: "Ghalanai",
      value: "Ghalanai",
    },
    {
      key: "Abbottabad",
      value: "Abbottabad",
    },
    {
      key: "Gilgit",
      value: "Gilgit",
    },
    {
      key: "Skardu",
      value: "Skardu",
    },
    {
      key: "Haripur",
      value: "Haripur",
    },
    {
      key: "Mansehra",
      value: "Mansehra",
    },
    {
      key: "Mingora",
      value: "Mingora",
    },
    {
      key: "Chitral",
      value: "Chitral",
    },
    {
      key: "Nowshera",
      value: "Nowshera",
    },
    {
      key: "Shaidu",
      value: "Shaidu",
    },
    {
      key: "Timergara",
      value: "Timergara",
    },
    {
      key: "Charsadda",
      value: "Charsadda",
    },
    {
      key: "Mardan",
      value: "Mardan",
    },
    {
      key: "Topi",
      value: "Topi",
    },
    {
      key: "Chakdarah",
      value: "Chakdarah",
    },
  ],
  Vehicle_Make: [
    {
      key: "TOYOTA YARIS GLI 1.3 MT",
      value: "TOYOTA YARIS GLI 1.3 MT",
    },
    {
      key: "TOYOTA YARIS ATIV 1.3 MT",
      value: "TOYOTA YARIS ATIV 1.3 MT",
    },
    {
      key: "TOYOTA YARIS 1.3 CVT",
      value: "TOYOTA YARIS 1.3 CVT",
    },
    {
      key: "TOYOTA YARIS ATIV 1.3 CVT",
      value: "TOYOTA YARIS ATIV 1.3 CVT",
    },
    {
      key: "TOYOTA ALTIS X CVT 1.8",
      value: "TOYOTA ALTIS X CVT 1.8",
    },
    {
      key: "TOYOTA YARIS ATIV X 1.5 MT",
      value: "TOYOTA YARIS ATIV X 1.5 MT",
    },
    {
      key: "TOYOTA YARIS ATIV X 1.5 CVT",
      value: "TOYOTA YARIS ATIV X 1.5 CVT",
    },
    {
      key: "TOYOTA ALTIS X MT 1.6",
      value: "TOYOTA ALTIS X MT 1.6",
    },
    {
      key: "TOYOTA ALTIS X AT 1.6",
      value: "TOYOTA ALTIS X AT 1.6",
    },
    {
      key: "TOYOTA ALTIS X AT 1.6 SE",
      value: "TOYOTA ALTIS X AT 1.6 SE",
    },
    {
      key: "TOYOTA ALTIS X CVT 1.8",
      value: "TOYOTA ALTIS X CVT 1.8",
    },
    {
      key: "TOYOTA ALTIS X GRANDE CVT 1.8 (BEIGE INTERIOR)",
      value: "TOYOTA ALTIS X GRANDE CVT 1.8 (BEIGE INTERIOR)",
    },
    {
      key: "TOYOTA ALTIS X GRANDE CVT 1.8 (BLACK INTERIOR)",
      value: "TOYOTA ALTIS X GRANDE CVT 1.8 (BLACK INTERIOR)",
    },
    {
      key: "TOYOTA FORTUNER 4X2 AT 2.7L STD G (PETROL)",
      value: "TOYOTA FORTUNER 4X2 AT 2.7L STD G (PETROL)",
    },
    {
      key: "TOYOTA FORTUNER 4X4 AT 2.7L HI V (PETROL)",
      value: "TOYOTA FORTUNER 4X4 AT 2.7L HI V (PETROL)",
    },
    {
      key: "TOYOTA FORTUNER 4X4 AT 2.8L SIGMA (DIESEL)",
      value: "TOYOTA FORTUNER 4X4 AT 2.8L SIGMA (DIESEL)",
    },
    {
      key: "TOYOTA FORTUNER LEGENDER",
      value: "TOYOTA FORTUNER LEGENDER",
    },
    {
      key: "TOYOTA REVO G MT",
      value: "TOYOTA REVO G MT",
    },
    {
      key: "TOYOTA REVO G AT",
      value: "TOYOTA REVO G AT",
    },
    {
      key: "TOYOTA REVO V AT",
      value: "TOYOTA REVO V AT",
    },
    {
      key: "TOYOTA REVO ROCCO",
      value: "TOYOTA REVO ROCCO",
    },
    {
      key: "HONDA CITY 1.2L MT",
      value: "HONDA CITY 1.2L MT",
    },
    {
      key: "HONDA CITY 1.2L CVT",
      value: "HONDA CITY 1.2L CVT",
    },
    {
      key: "HONDA CITY 1.5L CVT",
      value: "HONDA CITY 1.5L CVT",
    },
    {
      key: "HONDA CITY ASPIRE 1.5 MT",
      value: "HONDA CITY ASPIRE 1.5 MT",
    },
    {
      key: "HONDA CITY ASPIRE 1.5 CVT",
      value: "HONDA CITY ASPIRE 1.5 CVT",
    },
    {
      key: "HONDA BR-V I-VTEC S",
      value: "HONDA BR-V I-VTEC S",
    },
    {
      key: "HONDA CIVIC 1.5L TURBO M-CVT",
      value: "HONDA CIVIC 1.5L TURBO M-CVT",
    },
    {
      key: "HONDA CIVIC ORIEL 1.5L TURBO M-CVT",
      value: "HONDA CIVIC ORIEL 1.5L TURBO M-CVT",
    },
    {
      key: "HONDA CIVIC RS 1.5L TURBO LL-CVT",
      value: "HONDA CIVIC RS 1.5L TURBO LL-CVT",
    },
    {
      key: "SUZUKI ALTO VX",
      value: "SUZUKI ALTO VX",
    },
    {
      key: "SUZUKI ALTO VXR",
      value: "SUZUKI ALTO VXR",
    },
    {
      key: "SUZUKI ALTO AGS",
      value: "SUZUKI ALTO AGS",
    },
    {
      key: "SUZUKI WAGONR VXR",
      value: "SUZUKI WAGONR VXR",
    },
    {
      key: "SUZUKI WAGONR VXL",
      value: "SUZUKI WAGONR VXL",
    },
    {
      key: "SUZUKI WAGONR AGS",
      value: "SUZUKI WAGONR AGS",
    },
    {
      key: "SUZUKI CULTUS VXR",
      value: "SUZUKI CULTUS VXR",
    },
    {
      key: "SUZUKI CULTUS VXL",
      value: "SUZUKI CULTUS VXL",
    },
    {
      key: "SUZUKI CULTUS AGS",
      value: "SUZUKI CULTUS AGS",
    },
    {
      key: "SUZUKI SWIFT GL M/T",
      value: "SUZUKI SWIFT GL M/T",
    },
    {
      key: "SUZUKI SWIFT GL CVT",
      value: "SUZUKI SWIFT GL CVT",
    },
    {
      key: "SUZUKI SWIFT GLX CVT",
      value: "SUZUKI SWIFT GLX CVT",
    },
    {
      key: "SUZUKI BOLAN",
      value: "SUZUKI BOLAN",
    },
    {
      key: "SUZUKI CIAZ 1373 GL/A/T",
      value: "SUZUKI CIAZ 1373 GL/A/T",
    },
    {
      key: "SUZUKI JIMNY",
      value: "SUZUKI JIMNY",
    },
    {
      key: "KIA SPORTAGE ALPHA",
      value: "KIA SPORTAGE ALPHA",
    },
    {
      key: "KIA SPORTAGE FWD",
      value: "KIA SPORTAGE FWD",
    },
    {
      key: "KIA SPORTAGE ALPHA AWD",
      value: "KIA SPORTAGE ALPHA AWD",
    },
    {
      key: "KIA CARNIVAL GLS",
      value: "KIA CARNIVAL GLS",
    },
    {
      key: "KIA CARNIVAL GLS+",
      value: "KIA CARNIVAL GLS+",
    },
    {
      key: "KIA STONIC EX",
      value: "KIA STONIC EX",
    },
    {
      key: "KIA STONIC EX+",
      value: "KIA STONIC EX+",
    },
    {
      key: "KIA SORENTO 2.4 FWD",
      value: "KIA SORENTO 2.4 FWD",
    },
    {
      key: "KIA SORENTO 2.4 AWD",
      value: "KIA SORENTO 2.4 AWD",
    },
    {
      key: "KIA SORENTO 3.5 FWD",
      value: "KIA SORENTO 3.5 FWD",
    },
    {
      key: "KIA PICANTO MT",
      value: "KIA PICANTO MT",
    },
    {
      key: "KIA PICANTO AT",
      value: "KIA PICANTO AT",
    },
    {
      key: "HYUNDAI TUSCON FWD GLS SPORT",
      value: "HYUNDAI TUSCON FWD GLS SPORT",
    },
    {
      key: "HYUNDAI TUSCON AWD ULTIMATE",
      value: "HYUNDAI TUSCON AWD ULTIMATE",
    },
    {
      key: "HYUNDAI ELANTRA 2.0L",
      value: "HYUNDAI ELANTRA 2.0L",
    },
    {
      key: "HYUNDAI SONATA 2.5L",
      value: "HYUNDAI SONATA 2.5L",
    },
    {
      key: "HYUNDAI SONATA 2.0L",
      value: "HYUNDAI SONATA 2.0L",
    },
    {
      key: "FAW -CARRIER",
      value: "FAW -CARRIER",
    },
    {
      key: "FAW - XPV",
      value: "FAW - XPV",
    },
    {
      key: "FAW - V2",
      value: "FAW - V2",
    },
    {
      key: "MG - HS 1.5 TURBO PETROL",
      value: "MG - HS 1.5 TURBO PETROL",
    },
    {
      key: "MG - ZS 1.5 TURBO PETROL",
      value: "MG - ZS 1.5 TURBO PETROL",
    },
    {
      key: "PROTON X70 FWD",
      value: "PROTON X70 FWD",
    },
    {
      key: "PROTON X70 FWD",
      value: "PROTON X70 FWD",
    },
    {
      key: "PROTON SAGA MT",
      value: "PROTON SAGA MT",
    },
    {
      key: "PROTON SAGA AT",
      value: "PROTON SAGA AT",
    },
    {
      key: "PROTON SAGA ACE AT",
      value: "PROTON SAGA ACE AT",
    },
    {
      key: "CHANGAN ALSVIN 1.5L DCT ",
      value: "CHANGAN ALSVIN 1.5L DCT ",
    },
    {
      key: "CHANGAN ALSVIN 1.37L MT",
      value: "CHANGAN ALSVIN 1.37L MT",
    },
    {
      key: "CHANGAN ALSVIN 1.5L DCT LUMIERE",
      value: "CHANGAN ALSVIN 1.5L DCT LUMIERE",
    },
    {
      key: "CHANGAN KARVAAN MPV PLUS",
      value: "CHANGAN KARVAAN MPV PLUS",
    },
    {
      key: "CHANGAN KARVAAN MPV PLUS STANDARD",
      value: "CHANGAN KARVAAN MPV PLUS STANDARD",
    },
    {
      key: "OTHERS",
      value: "OTHERS",
    },
  ],
  lovList: [
    { key: "Fixed", value: "Fixed" },
    { key: "Floating", value: "Floating" },
  ],
  Relationship: [
    {
      key: "Spouse",
      value: "Spouse",
    },
    {
      key: "Father",
      value: "Father",
    },
    {
      key: "Son",
      value: "Son",
    },
    {
      key: "Daughter",
      value: "Daughter",
    },
    {
      key: "Mother",
      value: "Mother",
    },
    {
      key: "Brother",
      value: "Brother",
    },
    {
      key: "Sister",
      value: "Sister",
    },
  ],
  Insurance_company: [
    {
      key: "EFU General Insurance With Tracker",
      value: "EFU General Insurance With Tracker",
    },
    {
      key: "Jubilee General Insurance With Tracker",
      value: "Jubilee General Insurance With Tracker",
    },
    {
      key: "Adamjee Insurance With Tracker",
      value: "Adamjee Insurance With Tracker",
    },
    {
      key: "UBL Insurer Insurance with Tracker",
      value: "UBL Insurer Insurance with Tracker",
    },
    {
      key: "EFU General Insurance Without Tracker",
      value: "EFU General Insurance Without Tracker",
    },
    {
      key: "Jubilee General Insurance Without Tracker",
      value: "Jubilee General Insurance Without Tracker",
    },
    {
      key: "Adamjee Insurance Without Tracker",
      value: "Adamjee Insurance Without Tracker",
    },
    {
      key: "UBL Insurer Insurance without Tracker",
      value: "UBL Insurer Insurance without Tracker",
    },
  ],
  Financing_option: [
    {
      key: "Lien Based",
      value: "Lien Based",
    },
    {
      key: "Salaried",
      value: "Salaried",
    },
    {
      key: "Self Employed",
      value: "Self Employed",
    },
    {
      key: "Remittance Based",
      value: "Remittance Based",
    },
  ],
  Percentage: [
    {
      key: "15%",
      value: "15%",
    },
    {
      key: "16%",
      value: "16%",
    },
    {
      key: "17%",
      value: "17%",
    },
    {
      key: "18%",
      value: "18%",
    },
    {
      key: "19%",
      value: "19%",
    },
    {
      key: "20%",
      value: "20%",
    },
    {
      key: "21%",
      value: "21%",
    },
    {
      key: "22%",
      value: "22%",
    },
    {
      key: "23%",
      value: "23%",
    },
    {
      key: "24%",
      value: "24%",
    },
    {
      key: "25%",
      value: "25%",
    },
    {
      key: "26%",
      value: "26%",
    },
    {
      key: "27%",
      value: "27%",
    },
    {
      key: "28%",
      value: "28%",
    },
    {
      key: "29%",
      value: "29%",
    },
    {
      key: "30%",
      value: "30%",
    },
    {
      key: "31%",
      value: "31%",
    },
    {
      key: "32%",
      value: "32%",
    },
    {
      key: "33%",
      value: "33%",
    },
    {
      key: "34%",
      value: "34%",
    },
    {
      key: "35%",
      value: "35%",
    },
    {
      key: "36%",
      value: "36%",
    },
    {
      key: "37%",
      value: "37%",
    },
    {
      key: "38%",
      value: "38%",
    },
    {
      key: "39%",
      value: "39%",
    },
    {
      key: "40%",
      value: "40%",
    },
    {
      key: "41%",
      value: "41%",
    },
    {
      key: "42%",
      value: "42%",
    },
    {
      key: "43%",
      value: "43%",
    },
    {
      key: "44%",
      value: "44%",
    },
    {
      key: "45%",
      value: "45%",
    },
    {
      key: "46%",
      value: "46%",
    },
    {
      key: "47%",
      value: "47%",
    },
    {
      key: "48%",
      value: "48%",
    },
    {
      key: "49%",
      value: "49%",
    },
    {
      key: "50%",
      value: "50%",
    },
  ],
  Financing_Tenure: [
    {
      key: "1 Year",
      value: "1 Year",
    },
    {
      key: "2 Years",
      value: "2 Years",
    },
    {
      key: "3 Years",
      value: "3 Years",
    },
    {
      key: "4 Years",
      value: "4 Years",
    },
    {
      key: "5 Years",
      value: "5 Years",
    },
    {
      key: "6 Years",
      value: "6 Years",
    },
    {
      key: "7 Years",
      value: "7 Years",
    },
  ],
  Pricing_option: [
    {
      key: "Fixed",
      value: "Fixed",
    },
    {
      key: "Floating",
      value: "Floating",
    },
  ],
};
